export const TABLET_WIDTH_BREAKPOINT = 768;
